// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"dcf65eda","324":"816b59ab","453":"ce1c65cd","749":"cb5c0b51","932":"b6a00fd6","954":"b57443b3","958":"d0891bc1"}[chunkId] + ".chunk.js";
};